import { Address } from '../../types/commons';

import { validateZipCode } from './zip-code';

export const validateAddress = (value?: Partial<Address>): value is Address =>
  !!(
    value &&
    value.zip_code &&
    validateZipCode(value.zip_code) &&
    value.address &&
    value.city &&
    value.street_name &&
    (value.lat || value.lat === 0) &&
    (value.lng || value.lng === 0)
  );
